<template>
  <div class="review">
    <div class="message" :class="{ clamped }">{{ review.message }}</div>
    <button class="readmore" v-if="clamped" @click="clamped = false">Read more</button>
    <div class="author">{{ review.author }}</div>
    <img class="platform" :src="review.platformLogoUrl" />
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineProps({ review: Object })

const clamped = ref(true)
</script>

<style lang="scss" scoped>
.review {
  @include flex-column(12px);
  align-items: flex-start;
}

.message {
  color: black;
  font-weight: 400;
  font-style: italic;
  position: relative;

  &:before {
    content: '“';
  }

  &:after {
    content: '”';
  }
}

.clamped {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.readmore {
  @include base-font;
  color: $brand-tertiary;
}

.author {
  color: $grey-100;
}

.platform {
  height: 20px;
}
</style>
